import { CustomStatus, UserStatus } from './user-status';
import { IWorkspace } from './workspace';

export enum UserType {
  USER = 'user',
  GUEST = 'guest',
  INTEGRATION = 'integration',
  AI = 'ai',
}

export type IWorkspaceUser = {
  _id: string;
  email: string;
  name: string;
  picture?: string;
  active: boolean;
  workspace: IWorkspace;
  title: string;
  role: { _id: string; name: string; color: string }; // Refer to IRole (Not linked due circular dependency)
  status: UserStatus;
  lastAccess: string;
  customStatus: CustomStatus;
  type: UserType;
};

export type IWorkspaceTeam = {
  _id: string;
  main: boolean;
  name: string;
  picture: string;
  createdBy: IWorkspaceUser;
  participants: string[];
};

export type IWorkspaceInfo = IWorkspace & {
  users: IWorkspaceUser[];
  pendingInvites: { email: string; expireAt: string }[];
};

export type WorkspaceParticipant = { user: string } | { team: string };
